export default "__VITE_ASSET__vlbwEoCQ__"